const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "계획년도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "년도", "작업/활동", "환경영향", "계획일자"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  계획년도 — 계획일자가 없는 문서는 항상 포함
    if (!search.year) {
      search.year = new Date().getFullYear();
    }
    if (search.year) {
      conditions.push({
        boolean: "AND",
        conditions: [
          { key: "body.계획서.계획일자", operator: "LIKE", value: `${search.year}%`, boolean: "OR" },
          // 계획일자가 비어있는 문서도 포함한다. 중첩 조건은 value 가 required 라 빈 문자열을
          // 보낼 수 없으므로, "빈 문자열"을 뜻하는 정규식(^$)으로 매칭한다.
          { key: "body.계획서.계획일자", operator: "REGEXP", value: "^$", boolean: "OR" },
        ],
      });
    }

    // 사업장
    const params = new URLSearchParams(window.location.search);
    const fd = params.get("fd");
    conditions.push({ key: "body.stdInfo.field_name", operator: "=", value: fd });

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "년도",
        key: "header.year",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "소속2",
        key: "body.stdInfo.department",
      },
      {
        name: "작업/활동",
        key: "body.평가지표[0].작업",
      },
      {
        name: "환경영향",
        key: "body.평가지표[0].환경영향",
      },
      {
        name: "계획일자",
        key: "body.계획일자",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      const dataList = func.getContent(value).평가지표;
      switch (index) {
        case 0:
          return postContent.header.year; // 대상년도
        case 1:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 2:
          return func.getContent(value).stdInfo.department; // 소속2
        case 3:
          return dataList.map((e) => e.작업활동).join(", "); // 작업/활동
        case 4:
          return dataList.map((e) => e.환경영향).join(", "); // 환경영향
        case 5:
          return func.getCreatedDate(func.getContent(value).계획서.계획일자); // 계획일자
        case 6:
          return func.getContent(value).stdInfo.writer_name; // 작성자
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (/*nav*/) => {},
  getSearchKeyword: (/*nav*/) => {},
};
export default list;
